import React from 'react';
import styles from './Top.module.css';

import IcomButton from '@icons/IcomButton.svg';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mantine/core';

import Check from '@icons/Check.svg';
import { useTranslation } from 'react-i18next';

const Top = ({ organization, onSubmit, loading }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleBack = () => {
    navigate('/organizations?page=organizations')
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles}>
        <div className={styles.breadcrumbs}>
          <div className={styles.arrow} onClick={handleBack}>
            <img src={IcomButton} />
          </div>

          <div className={styles.current}>
            {organization.name}
          </div>
        </div>
      </div>

      <div className={styles.right}>
        <Button
          leftSection={<img src={Check} />}
          className={styles.button}
          loading={loading}
          onClick={onSubmit}
        >
          {t('save')}
        </Button>

      </div>
    </div>
  )
}

export default Top;
